:host {
  display: inline;
}

::slotted(mark) {
  background-color: var(--pv-color-attention-tint-4);
}
